<template>
  <table class="table">
    <tr>
      <th>{{ $t("hanwha_dvr.name")}}</th>
      <td class="fw-bold">{{ data.name }}</td>
    </tr>
    <tr>
      <th>{{ $t("hanwha_dvr.ip")}}</th>
      <td class="fw-bold">{{ data.ip }}</td>
    </tr>
    <tr>
      <th>{{ $t("hanwha_dvr.local_ip")}}</th>
      <td class="fw-bold">{{ data.local_ip }}</td>
    </tr>
    <tr>
      <th>{{ $t("hanwha_dvr.model")}}</th>
      <td class="fw-bold">{{ data.model }}</td>
    </tr>
    <tr>
      <th>{{ $t("hanwha_dvr.mac_address")}}</th>
      <td class="fw-bold">{{ data.mac_address }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props:{
    data: {
      type: Array | Object
    }
  }
}
</script>
